export default {
  title: 'Galleria',
  sections: {
    logo: 'Logo',
    web_images: 'Immagini galleria ordini online',
  },
  toasts: {
    image_uploaded: 'Modifiche salvate con successo',
    image_upload_failed: 'Salvataggio delle modifiche non riuscito',
  },
};
